import { ContractSummaryField } from './contract-summary-field';
import type { ContractSummarySchema } from './contract-summary-schema';

interface ContractSummaryFormProps {
  schema: ContractSummarySchema;
  value: Record<string, unknown>;
  onChange: (value: Record<string, unknown>) => void;
}

export function ContractSummaryForm({ schema, value, onChange }: ContractSummaryFormProps) {
  return (
    <div className="overflow-hidden rounded-md border border-border">
      <table className="w-full table-fixed border-collapse">
        <thead>
          <tr className="bg-muted text-left text-sm">
            <th className="w-1/2 px-3 py-2 font-semibold">Campo</th>
            <th className="w-1/2 px-3 py-2 font-semibold">Valor</th>
          </tr>
        </thead>
        <tbody>
          {schema.fields.map((field) => (
            <ContractSummaryField
              key={field.key}
              field={field}
              value={value[field.key]}
              onChange={(fieldValue) => onChange({ ...value, [field.key]: fieldValue })}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
